module.exports = __webpack_public_path__ + "img/enterprise_fbtj.e0db87f8.png";